<template>
  <div>
    <table>
      <slot />
    </table>
  </div>
</template>

<script>
export default {
  name: 'dx-table',
};
</script>

<style scoped lang="scss">
div {
  margin: var(--dx-space-size--xs);

  table {
    overflow: hidden;
    border-radius: calc(var(--dx-space-size--xs)/2);
    border-collapse: collapse;
    width: 100%;
    height: 100%;
  }
}
</style>
